export default "__VITE_ASSET__jvVuoGbd__"